import * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PresetNodesQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.ConfiguratorPresetNodeFilterInput>;
}>;


export type PresetNodesQuery = { __typename?: 'Query', configuratorPresetNodes?: { __typename?: 'configuratorPresetNodePaginator', data: Array<{ __typename?: 'configuratorPresetNode', id: string, definition: string, removed: boolean, preset_id: number, parent_node_id: number }> } | null };


export const PresetNodesDocument = gql`
    query PresetNodes($filter: configuratorPresetNodeFilterInput) {
  configuratorPresetNodes(filter: $filter) {
    data {
      id
      definition
      removed
      preset_id
      parent_node_id
    }
  }
}
    `;

/**
 * __usePresetNodesQuery__
 *
 * To run a query within a React component, call `usePresetNodesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePresetNodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePresetNodesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePresetNodesQuery(baseOptions?: Apollo.QueryHookOptions<PresetNodesQuery, PresetNodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PresetNodesQuery, PresetNodesQueryVariables>(PresetNodesDocument, options);
      }
export function usePresetNodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PresetNodesQuery, PresetNodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PresetNodesQuery, PresetNodesQueryVariables>(PresetNodesDocument, options);
        }
export type PresetNodesQueryHookResult = ReturnType<typeof usePresetNodesQuery>;
export type PresetNodesLazyQueryHookResult = ReturnType<typeof usePresetNodesLazyQuery>;
export type PresetNodesQueryResult = Apollo.QueryResult<PresetNodesQuery, PresetNodesQueryVariables>;